import { postpro } from '../index';

export const uploadFile = data => {
  return postpro('/brands/preupload', data, false);
};

export const uploadFilePublic = data => {
  return postpro('/r2/upload', data, false);
};
